// extracted by mini-css-extract-plugin
module.exports =  {"root":"oe8br5LqLZx0kXrsyP_R"};